import {
  useV2CreatePsaProjectMutation,
  useV2UpdatePsaProjectMutation,
} from "@generated";

export const usePsaProjectMutations = () => {
  const [createPsaProject, createState] = useV2CreatePsaProjectMutation();
  const [updatePsaProject, updateState] = useV2UpdatePsaProjectMutation();

  const create = (projectId: string, body: any) =>
    createPsaProject({ projectId, body }).unwrap();
  const update = (projectId: string, body: any) =>
    updatePsaProject({ projectId, body }).unwrap();

  return {
    create,
    update,
    states: { create: createState, update: updateState },
  };
};
